import { Component, OnInit } from '@angular/core';
import { slideToTop } from '../../router-animation/router-animation.component';
import { DatabaseService } from 'src/_services/DatabaseService'
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { debounceTime, tap, switchMap, finalize, retry } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DatePipe, Location } from '@angular/common';
import * as moment from 'moment';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { param } from 'jquery';
import * as _ from 'lodash';

@Component({
  selector: 'app-add-distribution',
  templateUrl: './add-distribution.component.html',
  animations: [slideToTop()],
  providers: [DatePipe],
})
export class AddDistributionComponent implements OnInit {
  savingFlag: boolean = false;
  states: any = [];
  division_list: any = [];
  district_list: any = [];
  userId: any;
  userName: any;
  params_id: any;
  params_type: any;
  brandList: any;
  city_list: any = [];
  city_area_list: any = [];
  pinCode_list: any = [];
  data: any = {};
  contact_person = {};
  asmList: any = [];
  assignUserList = [];
  assignUserId = [];
  dr_type: any;
  verifyFlag: boolean = false;
  verifybankFlag: boolean = false;
  verifyGstFlag: boolean = false;


  brand_list: any = [];
  competitorBrandList: any = [];
  urls = new Array<string>();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;
  searchMoviesCtrl = new FormControl();
  rsm: any = [];
  formData = new FormData();
  ass_user: any = [];
  brand: any = [];
  tmp_drlist: any = [];
  drlist: any = [];
  tmpsearchdr: any = {};
  file: any = {};
  file_name: any;
  imageError: any = '';
  filter_data: any;
  isLoading = false;
  errorMsg: string;
  active: any = {};
  submit: any = true;
  exist: boolean = false;
  tmp_userList: any = [];
  search: any = {};
  tmpsearch: any = {};
  ass_dist: any = [];
  myDate: Date;
  userData: any;
  pageType: any;
  front_img_id: any;
  back_img_id: any;
  pan_img_id: any;
  typecheck: any = '';
  istrue: boolean = false;
  bank_img_id: any;
  uploadurl: any;
  panBase64: boolean = false;
  bankImgBase64: boolean = false;
  docFrontBase64: boolean = false;
  docBackBase64: boolean = false;
  document_image: any;
  document_image_back: any;
  pan_img: any;
  image_id: any;
  image = new FormData();
  url: any;
  network_type: any = {}
  login_data: any = {};



  constructor(
    public service: DatabaseService,
    public rout: Router,
    public location: Location,
    public route: ActivatedRoute,
    public toast: ToastrManager,
    public session: sessionStorage,
    private http: HttpClient) {
    // this.uploadurl = service.uploadUrl;


    this.route.queryParams.subscribe(params => {
      this.uploadurl = this.service.uploadUrl + 'influencer_doc/'
      // this.uploadurl = this.service.uploadUrl + 'retailer_doc/'

      this.dr_type = params.type;
      this.data.country = 'India'

      if (params.type) {

        // this.params_network =  params.network;
        this.params_type = params.type;
        this.params_id = params.id;
        this.front_img_id = params.id;
        this.back_img_id = params.id;
        this.pan_img_id = params.id;
        this.bank_img_id = params.id;

      }
      this.myDate = new Date();
      this.userData = JSON.parse(localStorage.getItem('st_user'));
      this.userId = this.userData['data']['id'];
      this.userName = this.userData['data']['name'];

    });

    this.getStateList();
    this.getDivisonList();


    this.getSalesUser('');
    this.getBrand()
    this.route.params.subscribe(params => {
      this.network_type = this.route.queryParams['_value'];
      this.dr_type = params['id'];
      this.params_type = params['type'];
      this.pageType = params['pageType']

      if (params['type'] && params['id']) {
        this.params_id = params['id'];
        this.params_type = params['type'];
        if (params['pageType'] == 'edit') {
          this.distributorDetail();
        }
      }

      if ((this.dr_type == 1 || this.dr_type == 7)) {
        this.getWarehouse();
      }
      this.myDate = new Date();
      this.userData = JSON.parse(localStorage.getItem('st_user'));
      this.userId = this.userData['data']['id'];
      this.userName = this.userData['data']['name'];

    });


    this.session.getSession().subscribe(resp => {
      this.login_data = resp.data;
      console.log(this.login_data, 'login_data');

    })
  }

  ngOnInit() {
    this.searchMoviesCtrl.valueChanges.pipe(debounceTime(500), tap(() => {
      this.errorMsg = "";
      this.filter_data = [];
      this.isLoading = true;
    }),
      switchMap(value => this.http.post(this.service.dbUrl + "cp_suggestive/get_result", { 'value': value }).pipe(finalize(() => {
        this.isLoading = false
      })))).subscribe(data => {

        if (data['res'] == undefined) {
          this.errorMsg = data['Error'];
          this.filter_data = [];
        } else {
          this.errorMsg = "";
          this.filter_data = data['res'];
        }
      });
  }



  distributorDetail() {
    let id = { "id": this.params_type }
    this.service.post_rqst(id, "CustomerNetwork/distributorDetail").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.data = result['distributor_detail'];
        if (this.data.type == 3) {
          this.data.distributor_id = this.data.distributors_id.toString();
        }
        this.data.assigned_sales_user_name = this.data.assigned_sales_user_name.map(String);
        if (this.data.assigned_warehouse) {
          this.data.assigned_warehouse = this.data.assigned_warehouse.map(String);
        }

        this.data.credit_limit = this.data.credit_limit.toString();
        this.data.credit_period = this.data.credit_period.toString();
        this.data.id = result['distributor_detail']['id'];
        if (this.data.distributor_id != '') {
          this.distributorList('', '');
        }
        if (this.data.state) {
          this.getDistrict(1);
        }
        if (this.data.district != '') {
          this.getArea(1);
          this.getCity(1);
        }
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })
  }



  processPincode(pincode) {
    const pincodeValue = pincode;
    if (pincodeValue.length > 5) {
      this.service.post_rqst({ 'pincode': pincodeValue }, "CustomerNetwork/getPostalInfo").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.data.state = result['result'].state_name
          this.data.district = result['result'].district_name
          this.data.city = result['result'].city
          console.log(result, 'pincode result');
          if (!Array.isArray(result['result']) && Object.keys(result['result']).length > 0) {
          this.getDistrict(1)
          this.getCity(1)
          }
        }
        else {
          this.toast.errorToastr(result['statusMsg'])
        }
      }))
    }
  }


  getStateList() {
    this.service.post_rqst(0, "CustomerNetwork/getAllState").subscribe((response => {
      if (response['statusCode'] == 200) {

        this.states = response['all_state'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }



  getDistrict(val) {

    if (this.dr_type == 3) {
      this.distributorList('', this.data.state);
    }

    let st_name;
    if (val == 1) {
      st_name = this.data.state;
    }
    this.service.post_rqst({ 'state_name': st_name }, "CustomerNetwork/getAllDistrict").subscribe((response => {
      if (response['statusCode'] == 200) {

        this.district_list = response['all_district'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }




  getArea(val) {
    let dist_name;
    if (val == 1) {
      dist_name = this.data.district;
    }
    let value = { "state": this.data.state, "district": dist_name }
    this.service.post_rqst(value, "CustomerNetwork/getAreaData").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.city_area_list = response['area'];

      } else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }
  getCity(val) {
    let dist_name;
    if (val == 1) {
      dist_name = this.data.district;
    }
    let value = { "state": this.data.state, "district": dist_name, "pincode": this.data.pincode }
    this.service.post_rqst(value, "CustomerNetwork/get_city_list").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.city_list = response['city'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }
  getDivisonList() {
    this.service.post_rqst(0, "CustomerNetwork/getAllDivison").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.division_list = result['data'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }


  salesUser: any = [];
  getSalesUser(searcValue) {
    this.service.post_rqst({ 'search': searcValue }, "CustomerNetwork/salesUserList").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }

  MobileNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }

  }
  onUploadChange1(evt: any, f) {
    this.imageError = null;
    this.file = evt.target.files[0];
    this.file_name = this.file.name;


    const allowed_types = ['application/pdf'];
    this.typecheck = !_.includes("application/pdf", this.file.type)

    if (!_.includes(allowed_types, this.file.type)) {
      this.toast.errorToastr('Only Pdf File Accepted');
      this.file_name = ''
      this.istrue = false;
      return
    }
    let byte = 1000000    // equal to 1mb

    if (this.file.size > (byte * 20)) {
      this.toast.errorToastr('PDF file size is too large, maximum file size is 20 MB.');
      this.file_name = ''
      this.istrue = false;
      return
    }
    else { this.istrue = true; }

  }
  check_number() {
    if (this.data.mobile.length == 10) {
      this.service.post_rqst({ "mobile": this.data.mobile }, "CustomerNetwork/checkDrMobile").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.exist = false;
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.exist = true;
        }
      }))
    }
  }

  check_number1() {
    if (this.data.altNumber == 10) {
      this.service.post_rqst({ "mobile": this.data.altNumber }, "CustomerNetwork/checkDrMobile").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.exist = false;
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.exist = true;
        }
      }))
    }
  }

  check_number2() {
    if (this.data.altNumber2.length == 10) {
      this.service.post_rqst({ "mobile": this.data.altNumber2 }, "CustomerNetwork/checkDrMobile").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.exist = false;
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.exist = true;
        }
      }))
    }
  }

  check_number3() {
    if (this.data.altNumber3.length == 10) {
      this.service.post_rqst({ "mobile": this.data.altNumber3 }, "CustomerNetwork/checkDrMobile").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.exist = false;
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.exist = true;
        }
      }))
    }
  }

  getItemsList(search) {
    this.asmList = [];
    for (var i = 0; i < this.tmp_userList.length; i++) {
      search = search.toLowerCase();
      this.tmpsearch = this.tmp_userList[i]['name'].toLowerCase();
      if (this.tmpsearch.includes(search)) {
        this.asmList.push(this.tmp_userList[i]);
      }
    }
  }

  assign_to_distributor(id, index, e) {
    if (e.checked) {
      this.assignUserId.push(id);
      this.assignUserList.push(this.asmList[index]);
    }
    else {
      var index_val = index;
      for (var j = 0; j < this.assignUserId.length; j++) {
        if (this.asmList[index].id == this.assignUserId[j]) {
          this.assignUserId.splice(j, 1);
          this.removeUser(j);
        }
      }
    }
  }

  removeUser(index) {
    this.assignUserList.splice(index, 1);
  }


  user_assign_check(value, index, event) {

    if (event.checked) {
      if (this.rsm.indexOf(this.asmList[index]['id']) === -1) {
        this.rsm.push(value);
      }
    }
    else {
      for (var j = 0; j < this.asmList.length; j++) {
        if (this.asmList[index]['id'] == this.rsm[j]) {
          this.rsm.splice(j, 1);
        }
      }
    }

    this.ass_user = this.rsm
  }

  getBrand() {
    this.service.post_rqst({}, "CustomerNetwork/brandList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.brandList = result['result'];
        if (this.dr_type == 1 || this.dr_type == 7) {
          let brandCode = [];
          if (this.brandList.length > 0) {
            for (let i = 0; i < this.brandList.length; i++) {
              brandCode.push(this.brandList[i]['brand_code'])
            }
            this.data.brand = brandCode
          }
        }
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }
  product_Brand(value, index, event) {
    if (event.checked) {
      this.brand.push(value);
    }
    else {
      for (var j = 0; j < this.brand_list.length; j++) {
        if (this.brand_list[index]['brand_name'] == this.brand[j]) {
          this.brand.splice(j, 1);
        }
      }
    }
  }

  distributorList(searcValue, state) {
    this.service.post_rqst({ 'search': searcValue, 'state': state }, "CustomerNetwork/distributorsList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['distributors'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }

  back(): void {
    this.location.back()
  }
  Adhr_frnt_Upload(data: any) {
    for (let i = 0; i < data.target.files.length; i++) {
      let files = data.target.files[i];
      if (files) {
        let reader = new FileReader();
        this.docFrontBase64 = true;
        reader.onload = (e: any) => {
          this.front_img_id = '';
          this.data.document_image = e.target.result
        }
        reader.readAsDataURL(files);
      }
      else {
        this.docFrontBase64 = false;
      }
      this.image.append("" + i, data.target.files[i], data.target.files[i].name);
    }
  }
  Adhr_bck_Upload(data: any) {
    for (let i = 0; i < data.target.files.length; i++) {
      let files = data.target.files[i];
      if (files) {
        this.back_img_id = '';
        this.docBackBase64 = true;
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.data.document_image_back = e.target.result
        }
        reader.readAsDataURL(files);
      }
      else {
        this.docBackBase64 = false;
      }
      this.image.append("" + i, data.target.files[i], data.target.files[i].name);
    }
  }
  Pan_Upload(data: any) {
    for (let i = 0; i < data.target.files.length; i++) {

      let files = data.target.files[i];
      if (files) {
        this.pan_img_id = '';
        this.panBase64 = true;
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.data.pan_img = e.target.result
        }
        reader.readAsDataURL(files);
      }
      else {
        this.panBase64 = false;
      }
      this.image.append("" + i, data.target.files[i], data.target.files[i].name);
    }
  }
  bankImg_Upload(data: any) {
    for (let i = 0; i < data.target.files.length; i++) {

      let files = data.target.files[i];
      if (files) {
        this.bank_img_id = '';
        this.bankImgBase64 = true;
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.data.bank_img = e.target.result
        }
        reader.readAsDataURL(files);
      }
      else {
        this.bankImgBase64 = false;
      }
      this.image.append("" + i, data.target.files[i], data.target.files[i].name);
    }
  }

  DOBError: boolean = false;
  DOAError: boolean = false;



  warehouseList: any = [];
  getWarehouse() {
    this.service.post_rqst({}, "CustomerNetwork/fetchWarehouse").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.warehouseList = result['result'];
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }));
  }




  submitDetail() {

    // if(this.data.dr_code && this.selectedFile.length<=0 ){
    //     && this.pageType != 'edit'
    //   this.toast.errorToastr("Image Is Required");
    //   return;
    // }
    if (this.userId != '1') {
      this.ass_user[0] = this.userId;
      this.data.sales_executive = this.ass_user;
    }
    if(!this.data.state || !this.data.district || !this.data.city) {
      this.toast.errorToastr("State, District and City are required");
      return;
    }

    //  if (this.pageType == 'edit' && !(this.data.document_image && this.data.document_image_back) && (this.dr_type == 8 || this.dr_type == 13)) {
    //   this.toast.errorToastr('Aadhar Image Is Required');
    //   return


    // }

    // if (this.pageType == 'edit' && !this.data.pan_img && (this.dr_type == 8 || this.dr_type == 13)) {
    //   this.toast.errorToastr('Upload PAN Image Is Required');
    //   return
    // }

    // if (this.pageType == 'edit' && !this.data.bank_img && (this.dr_type == 8 || this.dr_type == 13)) {
    //   this.toast.errorToastr('Upload Cheque/Passbook Image Is Required');
    //   return


    // }

    //   if (this.pageType == 'edit' && this.data.cashfree_aadhar_status != 'VALID' && (this.dr_type == 8 || this.dr_type == 13)) {
    //   this.toast.errorToastr('Aadhar Verification Required');
    //   return
    // }

    // if (this.pageType == 'edit' && this.data.cashfree_pan_status != 'VALID' && (this.dr_type == 8 || this.dr_type == 13)) {
    //   this.toast.errorToastr('Pan Verification Required');
    //   return
    // }
    // if (this.pageType == 'edit' && this.data.cashfree_bank_status != 'VALID' && (this.dr_type == 8 || this.dr_type == 13)) {
    //   this.toast.errorToastr('Bank Verification Required');
    //   return
    // }


    if (this.data.dob) {
      this.data.dob = moment(this.data.dob).format('YYYY-MM-DD');
      this.data.dob = this.data.dob;
    }
    if (this.data.doa) {
      this.data.doa = moment(this.data.doa).format('YYYY-MM-DD');
      this.data.doa = this.data.doa;
    }
    this.data.created_by_name = this.userName
    this.data.created_by_id = this.userId;
    this.savingFlag = true;

    //    if(this.data.mobile == this.data.altNumber || this.data.mobile == this.data.altNumber2 || this.data.altNumber == this.data.altNumber2){
    //             this.toast.errorToastr('All numbers should be unique !!');
    //         }

    // return
    let header
    if (this.pageType == 'edit') {
      this.data.update_id = this.params_id;
      this.data.panBase64 = this.panBase64;
      this.data.bankImgBase64 = this.bankImgBase64;
      this.data.docFrontBase64 = this.docFrontBase64;
      this.data.docBackBase64 = this.docBackBase64;
      header = this.service.post_rqst({ "data": this.data, 'type': this.dr_type }, "CustomerNetwork/updateDistributors")
    }
    else {
      header = this.service.post_rqst({ "data": this.data, 'type': this.dr_type }, "CustomerNetwork/distributorsAdd")
    }
    header.subscribe((result => {

      if (result['statusCode'] == 200 && !this.params_id) {
        let state = this.data.state;
        let id = this.data.id;
        let last_id = result['last_id']
        console.log('====================================');
        console.log(last_id, 'last_id');
        console.log('====================================');
        let type = this.params_type;
        setTimeout(() => {
          this.getImageApi(last_id);

        }, 300);

        // this.rout.navigate([`distribution-list/${this.dr_type}/${this.params_type}/distribution-detail/` + result['last_id']], { queryParams: { state, id, type:this.dr_type} });
        this.rout.navigate([`distribution-list/${this.dr_type}/${this.params_type}/distribution-detail/` + result['last_id'] + '/Profile']);
        this.toast.successToastr(result['statusMsg']);
        this.service.dr_list();
      }
      else if (result['statusCode'] == 200 && this.params_id) {
        let state = this.data.state;
        let id = this.data.id;
        let last_id = result['last_id']
        setTimeout(() => {
          if (this.selectedFile.length > 0) {
            this.getImageApi(last_id);

          }
          console.log(this.file);
          if (this.file) {
            console.log(this.file);
            this.getPdfApi(last_id);
          }


        }, 300);
        console.log('====================================');
        console.log(this.data.id, 'this.data.id else');
        console.log('====================================');
        let type = this.params_type;

        this.rout.navigate([`distribution-list/${this.dr_type}/${this.params_type}/distribution-detail/` + result['last_id'] + '/Profile'], { queryParams: { state, id, type: this.dr_type } });

        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }));
  }


  form: any = {};
  getImageApi(last_id) {
    console.log(last_id);

    this.form.dr_type = this.dr_type
    this.form.attachment = this.selectedFile

    this.form.dr_id = last_id
    this.service.post_rqst({ "data": this.form }, "CustomerNetwork/insertCustomerImages").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }));
  }

  getPdfApi(last_id) {

    let fd = new FormData();   // <-- FIX: create new FormData()

    fd.append('customer', this.file, this.file.name);
    fd.append('dr_id', last_id);
    fd.append('dr_type', this.dr_type);

    this.service.FileData(fd, "CustomerNetwork/insertCustomerpdf")
      .subscribe(result => {
        if (result['statusCode'] == 200) {
          this.toast.successToastr(result['statusMsg']);
        } else {
          this.toast.errorToastr(result['statusMsg']);
        }
      });
  }


  selectedFile = [];
  fileChange(event: any) {
    for (var i = 0; i < event.target.files.length; i++) {
      this.selectedFile.push(event.target.files[i]);
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.urls.push(e.target.result);
        for (let index = 0; index < this.selectedFile.length; index++) {
          for (let urlIndex = 0; urlIndex < this.urls.length; urlIndex++) {
            if (index == urlIndex) {
              this.selectedFile[index]['path'] = this.urls[urlIndex];
            }
          }
        }
      }
      reader.readAsDataURL(event.target.files[i]);
    }
  }
  remove_image(i: any) {
    this.urls.splice(i, 1);
    this.selectedFile.splice(i, 1);
  }


  verifyAadhar() {


    this.verifyFlag = true;
    this.service
      .post_rqst({ upi_id: this.data.upi_id }, "Payout/validate_upi")
      .subscribe((result) => {

        if (result["statusCode"] == 200) {
          if (result["response"]["account_status"] == "VALID") {
            this.toast.successToastr(result["statusMsg"]);

            this.data.validate_upi_flag = result["response"]["account_status"];
            this.data.upi_name = result["response"]["name_at_bank"];

            this.verifyFlag = false;
          } else {
            this.toast.errorToastr(result["statusMsg"]);
            this.verifyFlag = false;
          }
        } else {
          this.toast.errorToastr(result["statusMsg"]);
          this.verifyFlag = false;
        }
      });
  }


  //    verifyPan() {

  //        if(!this.data.pan_no){
  //      this.toast.errorToastr('Enter Valid PAN No.');
  //       return;
  //   }




  //   this.data.verification_id=String(Math.floor(100000 + Math.random() * 900000))

  //   this.verifyFlag = true;
  //   this.service
  //     .post_rqst({ 'verification_id': this.data.verification_id,'pan':this.data.pan_no ,'name':this.data.pan_name, 'dob': this.data.dob }, "Influencer/pan_verification")
  //     .subscribe((result) => {

  //       if (result["statusCode"] == 200) {
  //         if (result['case']["response"]["status"] == "VALID") {
  //           this.toast.successToastr(result['case']["response"]["message"]);

  //           this.data.cashfree_pan_status = result['case']["response"]["status"];
  //           this.data.aadhaar_linked = result['case']["response"]["aadhaar_linked"];
  //           this.data.pan_name = result['case']["response"]["name_pan_card"];



  //           this.verifyFlag = false;
  //         } else {
  //           this.toast.errorToastr(result["case"]);
  //           this.verifyFlag = false;
  //         }
  //       }

  //       else if(result["statusCode"] == 400){
  //          this.toast.errorToastr(result["case"]);
  //         this.verifyFlag = false;
  //       }

  //       else {
  //         this.toast.errorToastr(result["statusMsg"]);
  //         this.verifyFlag = false;
  //       }
  //     });
  // }


  verifyPan() {

    if (!this.data.pan_no) {
      this.toast.errorToastr('Enter Valid PAN No.');
      return;
    }

    if (!this.data.adhar_no) {
      this.toast.errorToastr('Enter Aadhaar Number First');
      return;
    }

    this.data.verification_id = String(Math.floor(100000 + Math.random() * 900000));
    this.verifyFlag = true;

    this.service.post_rqst(
      {
        verification_id: this.data.verification_id,
        pan: this.data.pan_no,
        name: this.data.pan_name,
        dob: this.data.dob,
        id:this.pageType=='edit' ? this.params_type:'', 
      },
      "Influencer/pan_verification"
    ).subscribe(result => {

      this.verifyFlag = false;

      if (result["statusCode"] == 200) {

        let res =
          result['case'] &&
            result['case'].response
            ? result['case'].response
            : null;

        if (!res) {
          this.toast.errorToastr("Invalid API response");
          return;
        }

        // -------------------------------
        // 1️⃣ Aadhaar Mask Checking First
        // -------------------------------
        let masked = res.masked_aadhaar_number;
        let aadhaar_linked = res.aadhaar_linked;
        this.data.masked_aadhaar_number = res.masked_aadhaar_number;


        let userAadhar = this.data.adhar_no;
        console.log(userAadhar, 'userAadhar');
        let last4 = userAadhar.slice(-2);
        console.log(last4, 'last4');

        if (aadhaar_linked == false && !masked) {
          this.toast.errorToastr("Pan Is Not Linked with Aadhar");
          // this.data.adhar_verified = true;
          this.data.aadhaar_linked = res.aadhaar_linked
          this.data.cashfree_pan_status = "INVALID";
          return;

        }
        console.log(masked)
        console.log(masked.endsWith(last4))
        if (!masked || !masked.endsWith(last4)) {
          this.toast.errorToastr("Aadhaar number does not match PAN records.");
          this.data.adhar_verified = true;
          this.data.cashfree_pan_status = "INVALID";
          return;
        }

        // Aadhaar matched = success
        // this.data.adhar_verified = true;

        // -------------------------------
        // 2️⃣ Now check PAN status
        // -------------------------------
        if (res.status === "VALID") {

          this.toast.successToastr("PAN & Aadhaar verified successfully!");

          this.data.cashfree_pan_status = res.status;
          this.data.cashfree_aadhar_status = res.status;

          this.data.aadhaar_linked = res.aadhaar_linked;
          this.data.pan_name = res.name_pan_card;
          this.data.masked_aadhaar_number = res.masked_aadhaar_number;


        } else {
          this.data.cashfree_pan_status = "INVALID";
          this.toast.errorToastr(res.message || "PAN Verification Failed");
        }

      }
      else if (result["statusCode"] == 400) {
        this.toast.errorToastr(result["case"]);
        this.verifyFlag = false
      }
      else {
        this.toast.errorToastr(result["statusMsg"]);
        this.verifyFlag = false

      }

    });
  }








  verifyBank() {


    this.verifybankFlag = true;
    this.service
      .post_rqst({ id:this.pageType=='edit' ? this.params_type:'','bank_account': this.data.account_no, 'ifsc': this.data.ifsc_code, 'name': this.data.account_holder_name, }, "Influencer/account_verification")
      .subscribe((result) => {

        if (result["statusCode"] == 200) {
          if (result["case"]["response"]["account_status"] == "VALID") {

            this.data.cashfree_bank_status = result['case']["response"]["account_status"];
            this.data.account_holder_name = result['case']["response"]["name_at_bank"];
            this.data.bank_name = result['case']["response"]["bank_name"];
            this.toast.successToastr(result["statusMsg"]);

            this.verifybankFlag = false;
          } else {
            this.toast.errorToastr(result["case"]);
            this.verifybankFlag = false;
          }
        }

        else if (result["statusCode"] == 400) {
          this.toast.errorToastr(result["case"]);
          this.verifybankFlag = false;
        }

        else {
          this.toast.errorToastr(result["statusMsg"]);
          this.verifybankFlag = false;
        }
      });
  }
  verifyGst() {
    if (!this.data.gst) {
      this.toast.errorToastr('Please enter GST Number first');
      return;
    }

    this.verifyGstFlag = true;

    this.service.post_rqst(
      { gstin: this.data.gst, id: this.pageType == 'edit' ? this.params_type : '' },
      'Influencer/gst_verification'
    ).subscribe(result => {
      this.verifyGstFlag = false;

      if (result['statusCode'] == 200) {
        const res = result['case'] && result['case'].response ? result['case'].response : null;

        if (!res) {
          this.toast.errorToastr('Invalid API response');
          return;
        }

        this.data.cashfree_gst_status = 'VALID';
        this.data.gst_business_name = res.trade_name_of_business || res.legal_name_of_business;
        this.data.gst_gstin_status = res.gst_in_status;
        this.data.gst_taxpayer_type = res.taxpayer_type;
        this.data.gst_constitution = res.constitution_of_business;
        this.data.gst_registration_date = res.date_of_registration;
        this.data.gst_state_jurisdiction = res.state_jurisdiction;

        const addr = res.principal_place_split_address || {};
        this.data.gst_state    = addr.state    || '';
        this.data.gst_district = addr.district || '';
        this.data.gst_city     = addr.city     || addr.location || '';
        this.data.gst_pincode  = addr.pincode  || '';

        this.toast.successToastr('GST Verified Successfully!');
      } else if (result['statusCode'] == 400) {
        this.toast.errorToastr(result['case']);
        this.data.cashfree_gst_status = 'INVALID';
      } else {
        this.toast.errorToastr(result['statusMsg']);
        this.data.cashfree_gst_status = 'INVALID';
      }
    });
  }

  textOnly(event: KeyboardEvent) {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);

    // allow alphabets & space only
    if (!/^[a-zA-Z ]$/.test(char)) {
      event.preventDefault(); // ⛔ typing block
      return false;
    }
    return true;
  }

}
